import * as type from '../actions/types';

const initialState = {
    commissionDetails: {},
    loading: false,
    error: null,
}

export default function commissionDetailsData(state = initialState, action) {
    switch (action.type) {
        case type.GET_COMMISSION_DETAILS_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_COMMISSION_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                commissionDetails: action.data,
            }
        case type.GET_COMMISSION_DETAILS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}